<template>
  <span>
    <div class="upload-list-wrapper" v-if="showStyle === 'list'">
      <div class="file-list-title" id="file-list" v-show="update && fileList.length < max">
        <span class="iconfont iconupload uploader-icon font-size-20"></span>
        <div class="uploader-title">{{ opts.title }}</div>
      </div>
      <div class="file-list-wrapper">
        <FileListShow :list="fileList" :manage="manage" @on-remove="removeFile"></FileListShow>
      </div>
    </div>
    <div class="sample-upload-list-wrapper flex-between-top" v-if="showStyle === 'sample-list'">
      <div class="sample-file-list-title c-gray cursor-pointer" id="sample-file-list" v-show="update && fileList.length < max">
        <span class="iconfont iconupload uploader-icon font-size-20"></span>
        <span class="uploader-title">{{ opts.title }}</span>
      </div>
      <div class="file-list-wrapper" style="flex-grow: 1">
        <FileListShow :list="fileList" :manage="manage" @on-remove="removeFile"></FileListShow>
      </div>
    </div>
    <div class="upload-thumbnail-wrapper" v-if="showStyle === 'thumbnail'">
      <div class="file-thumbnail-title" id="file-thumbnail" v-show="update && fileList.length < max">
        <GeneralIconPlus :size="16" class="mr4" />
        <span class="uploader-title">{{ opts.title }}</span>
      </div>
      <FileThumbnailShow :list="fileList" :manage="manage" @on-remove="removeFile"></FileThumbnailShow>
    </div>
    <div class="c-ccc font-size-12 line-height-12 one-row-ellipsis" v-if="update">
      <span v-if="option.tip">{{ option.tip }}</span>
      <span v-else>
        <span v-if="config.acceptExt">支持文件类型：{{ config.acceptExt }}格式文件</span>
        <span v-if="config.fileSingleSizeLimit">，且不超过{{ config.fileSingleSizeLimit / 1024 / 1024 }}M</span>
      </span>
    </div>
  </span>
</template>

<script>
import { deepCopy, isArray } from '@Utils/index'
import BiliYunBUploader from '@bilibili-studio/biliyun-b-uploader'
import FileListShow from './FileListShow'
import FileThumbnailShow from './FileThumbnailShow'
import { GeneralIconPlus } from '@bilibili-business/icons-vue-plus'

const defaultOption = {
  cdnOptions: {
    profile: 'business/bup',
    os: 'upos'
  },
  // 自动重试 2s 间隔
  autoRetry: true,
  // 一个文件整体大小限制 字节 byte
  fileSingleSizeLimit: 8 * 1024 * 1024 * 1024,
  // 一个文件单位切片大小，最小4MB
  chunkSize: 4 * 1024 * 1024,
  // 单个文件上传，分片的并发数量
  pipeChunkLimit: 2,
  // 单次上传，可以上传多个文件
  multiple: false,
  // 允许重复文件
  allowDuplicate: true,
  // 允许上传的文件后缀类型 格式 'type1,type2,type3...'
  acceptExt: 'doc,docx,pdf,csv,xls,jpeg,jpg,png,gif,mp4,flv,avi,wmv,mov,webm,mpeg4,ts,mpg,rm,rmvb,mkv,m4v,webp', // 允许上传的文件后缀类型 格式 'type1,type2,type3...'
  // 错误捕获上报 关闭捕获 error_tracker = '' default =
  error_tracker: 'weblog'
}

export default {
  emits: ['update:modelValue', 'on-change'],
  name: 'BusinessUploader',
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next()
  },
  beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    next()
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    showStyle: {
      type: String,
      default: 'list'
    },
    action: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default() {
        return {}
      }
    },
    max: {
      type: Number,
      default: 100
    },
    success: {
      type: Function
    },
    delete: {
      type: Function
    },
    // 是否具有操作 删除
    manage: {
      type: Boolean,
      default: true
    },
    // 是否可以上传
    update: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    modelValue: {
      deep: true,
      handler(newVal) {
        this.$data.fileList = deepCopy(newVal)
      }
    }
  },
  data() {
    return {
      fileList: deepCopy(this.modelValue),
      config: {
        ...defaultOption
      },
      uploader: null,
      opts: {
        title: '上传文件',
        ...this.option
      }
    }
  },
  created() {},
  mounted() {
    this.config = { ...defaultOption, ...this.option }

    this.$nextTick(() => {
      this.init()
    })
  },
  unmounted() {
    this.uploader.destroyAll()
    this.uploader = null
  },
  methods: {
    removeFile(value) {
      const index = this.findFileIndex(value.oss_key)

      if (index !== -1) {
        this.uploader.destroy(value.boxId)
        this.fileList.splice(index, 1)
        this.emitValue(this.fileList)
      }
    },
    addFile(value) {
      this.fileList.push(value)
    },
    findFileIndex(val) {
      const list = isArray(this.fileList) ? this.fileList : []
      return list.findIndex(item => item.oss_key === val)
    },
    init() {
      const _this = this
      const typeMap = {
        list: 'file-list',
        'sample-list': 'sample-file-list',
        thumbnail: 'file-thumbnail'
      }
      const target = typeMap[this.showStyle] || 'file-list'
      const dom = document.getElementById(target)
      this.createInstance()
      this.uploader.appendBtn(dom)

      this.uploader.on('BeforePreUpload', _this.beforePreUpload)
      this.uploader.on('BeforeUpload', _this.beforeUpload)
      this.uploader.on('UploadProgress', _this.uploadProgress)
      this.uploader.on('BeforeFileUploaded', _this.beforeFileUploaded)
      this.uploader.on('FileUploaded', _this.fileUploaded)
      this.uploader.on('Error', _this.error)
    },
    createInstance() {
      const uploader = new BiliYunBUploader(this.config)
      this.uploader = uploader
    },
    // 文件选择完毕，开始单个队列所有上传钩子开始前
    beforePreUpload(box, next) {
      next()
    },
    // 文件选择后，同步云端完成后触发钩子
    beforeUpload(box) {
      this.uploader.updateBox(box.id, 'uposCompleteQuery', {
        profile: '',
        complete_use_profile: false
      })
    },
    // 文件上传过程中，每一片上传完成后触发钩子
    uploadProgress(box) {},
    // 上传结束，合片请求开始阶段
    beforeFileUploaded(box) {},
    // 文件上传过程中，分片全部上传完毕，云端也同步完毕
    fileUploaded(box) {
      const { hookSet = {}, name } = box

      this.addFile(
        deepCopy({
          oss_key: (hookSet.upos_uri || '').replace(/^upos:\/\//, '/'),
          file_name: name,
          url: ''
        })
      )

      this.emitValue(this.fileList)
      this.$Message.success('上传成功!')
    },
    emitValue(fileList) {
      this.$emit('update:modelValue', fileList)
      this.$emit('on-change', fileList)
    },
    error(box) {
      let showText = box.detail || ''

      const opts = this.uploader
      switch (box.type) {
        case 'Q_EXCEED_NUM_LIMIT':
          if (opts && opts.fileSingleSizeLimit) {
            showText = '文件数量超出限制，只能上传' + opts.fileSingleSizeLimit + '个文件'
          }
          break
        case 'EXT_NOT_ACCEPTED_ERROR':
          if (opts && opts.acceptExt) {
            showText = '类型不支持，支持列表：' + opts.acceptExt.replace(/,/g, ', ')
          }
          break
        case 'MAX_FILE_SIZE_ERROR':
          if (opts && opts.fileSizeLimit) {
            showText = '文件大小不能超过' + opts.fileSizeLimit
          }
          break
        case 'UPLOAD_ERROR':
        case 'RUNTIME_ERROR':
        case 'BEFORE_SEND_ERROR':
        case 'AFTER_SEND_ERROR':
      }

      this.$Message.error(showText)
    }
  },
  components: {
    FileListShow,
    FileThumbnailShow,
    GeneralIconPlus
  }
}
</script>

<style lang="less">
.upload-list-wrapper {
  vertical-align: middle;

  .file-list-title {
    vertical-align: middle;
    align-items: center;
    height: 90px;
    border: 1px solid #dadae1;
    border-radius: 2px;
    padding: 10px;
    color: #8d9099;
    text-align: center;
    cursor: pointer;
    margin-right: 12px;
  }
}

.uploader-icon {
  font-size: 24px;
  vertical-align: middle;
  /*width: 24px;*/
}

.error-color {
  color: #e21223;
}

.pink-color {
  color: #fb7299;
}

.sample-upload-list-wrapper {
  .sample-file-list-title {
    vertical-align: middle;
    display: inline-block;
    width: 100px;
    border: 1px solid #dadae1;
    text-align: center;
    border-radius: 2px;
    margin-right: 8px;
    margin-bottom: 8px;
    flex-shrink: 0;
  }
}

.upload-thumbnail-wrapper {
  vertical-align: middle;

  .file-thumbnail-title {
    /*align-items: center;*/
    vertical-align: middle;
    display: inline-block;
    width: 120px;
    height: 90px;
    border: 1px solid #dadae1;
    border-radius: 2px;
    padding: 25px 10px;
    margin-right: 12px;
    margin-bottom: 8px;
    color: #8d9099;
    text-align: center;
    cursor: pointer;
  }
}
</style>
